import { useQuery, type UseQueryOptions } from '@tanstack/vue-query'
import { getAssessmentProgress } from '@/api/assessment'
import { type MaybeRef } from 'vue'
import { useUrlSearchParams } from '@vueuse/core'

export function useAssessmentProgress(
  handProgress?: MaybeRef<number | undefined>,
  options?: Partial<Omit<UseQueryOptions, 'queryKey' | 'queryFn'>>
) {
  const params = useUrlSearchParams()

  return useQuery({
    queryKey: ['assessment-progress', handProgress],
    queryFn: () => getAssessmentProgress(Number(params.maxAssessmentHands) || undefined),
    refetchOnWindowFocus: false,
    ...options
  })
}
